import { useLocation } from 'react-router-dom';

import { Page } from '@cast/shared-layout-ui';

import { ErrorPage403 } from 'components/error-pages';

export const ForbiddenPage = () => {
  const { state } = useLocation();

  return (
    <Page analytics="Forbidden">
      <ErrorPage403 body={state?.message} action={null} />
    </Page>
  );
};
